import {ROLES} from '@/models';

export const showTabsInMenuListForAccountManagerOnly = (
  menuList: {
    title: string;
    children?: { title: string }[];
  }[],
  userRole?: string
): any[] => {
  const mappedMenu = menuList
  mappedMenu
    .filter((item) => item.title === 'dashboard' || item.title === 'experiences' || item.title === 'users')
    ?.map((el) => {
      if (el.title === 'experiences' && userRole === ROLES.account_manager) {
        el.children = el.children?.filter((item) => item.title === 'experiences');
      }
      if (el.title === 'users' && userRole === ROLES.account_manager) {
        el.children = el.children?.filter((item) => item.title === 'coaches');
      }
      return el;
    });
  return mappedMenu;
};
